
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-detalles';
    import { Curso, Participante } from '@/__env/lib/Cursos';
    import pregunta from './cursos-detalles-resumen-preguntas-pregunta.vue';
    import { Resultado } from '@/__env/lib/Cursos/Resultado';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            pregunta,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeCurso { return Model; }
        public get Curso(): Curso { return this.Controlador.Curso; }
        public get Participante(): Participante { return this.Controlador.Seleccionado; }


        @Prop()
        public Estado: string;

        @Prop()
        public Resultado: Resultado;


        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        async mounted()
        {

        }


    }
